.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.meta {
  max-width: 290px;
}

.metaMaxWidth {
  max-width: calc(100% - 55px);
}

.date {
  color: var(--paletteBlue2);
}

.noteContainer {
  border-bottom: 1px solid var(--paletteNeutral1);
  padding: var(--spacingMd);
}
